import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import hotkeys from './hotkeys/hotkeys.js'
import open from './open.js'

export default contract({
  hotkeys,
  open: array([
    open
  ]),
})
